<template>
    <section>
        <div class="row mt-5">
            <div class="col-lg-3 col-sm-6">
                <!-- Section 1 -->
                <form v-on:submit.prevent="save" disabled>
                <div class="card shadow-sm mb-4 border-0">
                    <div class="card-header background-primary">
                        <div class="row">
                            <div class="col">
                                <span class="h4 font-weight-medium text-white mb-0">
                                    Profil Siswa
                                </span>
                            </div>
                            <div class="col-auto">
                                <div class="edit-action">
                                    <button type="button" class="btn btn-link h4 p-0 my-0" v-on:click="toggleInput">
                                        Edit
                                    </button>
                                </div>
                                <div class="input-action">
                                    <button type="submit" class="btn btn-danger btn-sm btn-outline-white h4 my-0 mr-2">
                                        Save
                                    </button>
                                    <button type="button" class="btn btn-danger btn-sm btn-outline-white h4 my-0" v-on:click="toggleInput">
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row mb-3 align-items-center">
                            <div class="col-12">
                                <div v-bind:style="'background-image: url(' + imagePreview +')'" class="user-avatar rounded-circle">
                                    <!-- Fitur upload dimatikan agar siswa tidak bisa ganti foto sendiri -->
                                     
                                    <div class="overlay rounded-circle text-center text-white" v-on:click="$refs.upload.click()">
                                        <i class="fa fa-upload"></i>
                                    </div>
                                    <input ref="upload" type="file" class="form-control" v-on:change="preview($event); upload();" accept="image/*" /> 
                                    
                                </div>
                            </div>
                        </div>
                        <div class="row mb-1 align-items-center">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted h4 mb-0 form-divider">Username</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 p-1">
                                <h4 class="font-weight-medium mb-0 text-loading" v-if="student.user">{{ student.user.username }}</h4>
                            </div>
                        </div>
                        <div class="row mb-1 align-items-center">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted h4 mb-0 form-divider">Nama Lengkap</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 p-1">
                                <h4 class="font-weight-medium mb-0 text-loading" v-if="student.user">{{ student.user.name }}</h4>
                            </div>
                        </div>
                        <div class="row mb-1 align-items-center">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted h4 mb-0 form-divider">Alamat Email</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 p-1">
                                <h4 class="font-weight-medium mb-0 text-loading" v-if="student.user">{{ student.user.email }}</h4>
                            </div>
                        </div>
                        <div class="row mb-1 align-items-center">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted h4 mb-0 form-divider">Asal Sekolah</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 p-1">
                                <h4 class="font-weight-medium mb-0 text-loading" v-if="student.school">{{ student.school.name }}</h4>
                            </div>
                        </div>
                        <div class="row mb-1 align-items-center">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted h4 mb-0 form-divider">Prodi Sekolah</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 p-1">
                                <h4 class="font-weight-medium mb-0 text-loading" v-if="student.grade">{{ student.grade.name }}</h4>
                            </div>
                        </div>
                        <div class="row mb-1 align-items-center" v-for="attribute in ['tempat_lahir']">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted h4 mb-0 form-divider">{{ humanize(attribute) }}</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                            </div>
                        </div>
                        <div class="row mb-1 align-items-center">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted h4 mb-0 form-divider">Tanggal Lahir</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                <input type="date" v-model="form.profile.tanggal_lahir" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                            </div>
                        </div>
                        <div class="row mb-1 align-items-center">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted h4 mb-0 form-divider">Jenis Kelamin</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                <div class="wrapper-input">
                                    <div class="form-check form-check-inline py-1" v-for="gender in ['Laki-laki', 'Perempuan']">
                                        <div class="custom-control custom-radio">
                                            <input v-model="form.profile.jenis_kelamin" type="radio" class="custom-control-input" v-bind:value="gender" v-bind:id="'input-jenis_kelamin-' + gender" />
                                            <label class="custom-control-label h4" v-bind:for="'input-jenis_kelamin-' + gender">{{ gender }}</label>
                                        </div>
                                    </div>
                                </div>
                                <input class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" disabled v-bind:value="form.profile.jenis_kelamin" />
                            </div>
                        </div>
                        <div class="row mb-1 align-items-center" v-for="attribute in ['alamat_rumah', 'kode_pos', 'nomor_telp_rumah', 'nomor_hp_siswa']">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted h4 mb-0 form-divider">{{ humanize(attribute) }}</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                            </div>
                        </div>
                        <div class="row mb-1 align-items-center"  v-for="attribute in ['pembelajaran']">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted h4 mb-0 form-divider">{{ humanize(attribute) }}</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 p-1">
                                <h4 class="font-weight-medium mb-0">
                                    {{ student.additionals[attribute] }}
                                </h4>
                            </div>
                        </div>
                    </div>
                </div>
								</form>

                <h4 class="font-weight-bold text-danger mt-5 mb-4">
                    Jika ada data yang salah atau ingin diubah, 
                    anda bisa melakukan permintaan pengubahan data pada admin
                </h4>

                <div class="row mb-5">
                    <div class="col">
                        <button v-on:click="modalShow = true" type="button" class="btn btn-sm btn-danger btn-block">
                            Request Edit
                        </button>
                    </div>
                    <div class="col">
                        <router-link v-bind:to="{name: 'index'}" class="btn btn-sm btn-outline-danger btn-block">
                            Cancel
                        </router-link>
                    </div>
                </div>
            </div> 

            
	    <div class="col-lg-3 col-sm-6">
                <!-- Section 3 -->
		<form v-on:submit.prevent="save" disabled>
                <div class="card shadow-sm mb-4 border-0">
                    <div class="card-header background-primary">
                        <div class="row">
                            <div class="col">
                                <span class="h4 font-weight-medium text-white mb-0">
                                    Data Kepesertaan Siswa BTA
                                </span>
                            </div>
			    <div class="col-auto">
                                        <div class="edit-action">
                                            <button type="button" class="btn btn-link h4 p-0 my-0" v-on:click="toggleInput">
                                                Edit
                                            </button>
                                        </div>
                                        <div class="input-action">
                                            <button type="submit" class="btn btn-danger btn-sm btn-outline-white h4 my-0 mr-2">
                                                Save
                                            </button>
                                            <button type="button" class="btn btn-danger btn-sm btn-outline-white h4 my-0" v-on:click="toggleInput">
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row mb-1 align-items-center">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted h4 mb-0 form-divider">Tahun Ajaran</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 p-1">
                                <h4 class="font-weight-medium mb-0">
                                    {{ student.term.name }}
                                </h4>
                            </div>
                        </div>
                        <div class="row mb-1 align-items-center" v-for="attribute in ['nomor_formulir']">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted h4 mb-0 form-divider">{{ humanize(attribute) }}</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 p-1">
                                <h4 class="font-weight-medium mb-0">
                                    {{ student.additionals[attribute] }}
                                </h4>
                            </div>
                        </div>
                        <div class="row mb-1 align-items-center">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted h4 mb-0 form-divider">No. Kepesertaan</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 p-1">
                                <h4 class="font-weight-medium mb-0 text-loading">{{ student.identity }}</h4>
                            </div>
                        </div>
                        <div class="row mb-1 align-items-center">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted h4 mb-0 form-divider">Tanggal Daftar</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 p-1">
                                <h4 class="font-weight-medium mb-0 text-loading"><template v-if="student.registeredAt">{{ $moment(student.registeredAt, "YYYY-MM-DD").format('D MMMM YYYY') }}</template></h4>
                            </div>
                        </div>
                        <div class="row mb-1 align-items-center">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted h4 mb-0 form-divider">Cabang</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 p-1">
                                <h4 class="font-weight-medium mb-0 text-loading" v-if="student.branch">{{ student.branch.name }}</h4>
                            </div>
                        </div>
                        <div class="row mb-1 align-items-center">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted h4 mb-0 form-divider">Program</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 p-1">
                                <h4 class="font-weight-medium mb-0" v-if="Object.keys(guessBranchProgram).length">
                                    {{ guessBranchProgram.grade.name }} - {{ guessBranchProgram.programType.name }}
                                </h4>
                            </div>
                        </div>
                        <div class="row mb-1 align-items-center">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted h4 mb-0 form-divider">Pola Semester 1</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 p-1">
                                <h4 class="font-weight-medium mb-0" v-if="student.studentVerified && student.studentVerified.pattern && Object.keys(student.studentVerified.pattern).length > 1">
                                    {{ patternLabel(student.studentVerified.pattern) }}
                                </h4>
                            </div>
                        </div>
                        <div class="row mb-1 align-items-center">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted h4 mb-0 form-divider">Kelas Semester 1</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 p-1">
                                <h4 class="font-weight-medium mb-0" v-if="student.studentVerified && student.studentVerified.branchClass">
                                    {{ student.studentVerified.branchClass.name }}
                                </h4>
                            </div>
                        </div>
			            <div class="row mb-1 align-items-center">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted h4 mb-0 form-divider">Pola Semester 2</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 p-1">
                                <h4 class="font-weight-medium mb-0" v-if="student.studentVerified && student.studentVerified.secondPattern && Object.keys(student.studentVerified.secondPattern).length > 1">
                                    {{ patternLabel(student.studentVerified.secondPattern) }}
                                </h4>
                            </div>
                        </div>
                        <div class="row mb-1 align-items-center">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted h4 mb-0 form-divider">Kelas Semester 2</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 p-1">
                                <h4 class="font-weight-medium mb-0" v-if="student.studentVerified && student.studentVerified.secondBranchClass">
                                    {{ student.studentVerified.secondBranchClass.name }}
                                </h4>
                            </div>
                        </div>
                        <div class="row mb-1 align-items-center">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted h4 mb-0 form-divider">Sesi Intensif</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 p-1">
                                <h4 class="font-weight-medium mb-0" v-if="student.studentVerified && student.studentVerified.intensiveSchedule">
                                    {{ student.studentVerified.intensiveSchedule.name }}
                                </h4>
                            </div>
                        </div>
                        <div class="row mb-1 align-items-center">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted h4 mb-0 form-divider">Kelas Super Intensif UTBK</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 p-1">
                                <h4 class="font-weight-medium mb-0" v-if="student.studentVerified && student.studentVerified.thirdBranchClass">
                                    {{ student.studentVerified.thirdBranchClass.name }}
                                </h4>
                            </div>
                        </div>
                        <div class="row mb-1 align-items-center">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted h4 mb-0 form-divider">Kelas Intensif Mandiri</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 p-1">
                                <h4 class="font-weight-medium mb-0" v-if="student.studentVerified && student.studentVerified.fourthBranchClass">
                                    {{ student.studentVerified.fourthBranchClass.name }}
                                </h4>
                            </div>
                        </div>
                        <!--<div class="row mb-1 align-items-center">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted h4 mb-0 form-divider">Kelas Intensif</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 p-1">
                                <h4 class="font-weight-medium mb-0" v-if="student.studentVerified && student.studentVerified.intensiveClass">
                                    {{ student.studentVerified.intensiveClass.name }}
                                </h4>
                            </div>
                        </div>-->
                        <div class="row mb-1 align-items-center">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted h4 mb-0 form-divider">Ruang Placement test</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 p-1">
                                <h4 class="font-weight-medium mb-0" v-if="student.studentVerified">
                                    {{ student.studentVerified.placement }}
                                </h4>
                            </div>
                        </div>
                        <div class="row mb-1 align-items-center">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted h4 mb-0 form-divider">Tahapan Pembayaran</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 p-1">
                                <h4 class="font-weight-medium mb-0" v-if="student.studentVerified">
                                    {{ student.studentVerified.payment }}
                                </h4>
                            </div>
                        </div>
                        <div class="row mb-1 align-items-center">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted h4 mb-0 form-divider">Rencana Pola Hari</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 p-1">
                                <h4 class="font-weight-medium mb-0" v-if="student.studentVerified">
                                    {{ student.studentVerified.paymentNote }}
                                </h4>
                            </div>
                        </div>
                        <div class="row mb-1 align-items-center">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted h4 mb-0 form-divider">Informasi BTA dari</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 p-1">
                                <h4 class="font-weight-medium mb-0">
                                    {{ student.additionals.ukuran_jaket }}
                                </h4>
                            </div>
                        </div>
                        <div class="row mb-1 align-items-center">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted h4 mb-0 form-divider">Pembayaran Tahap 1</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 p-1">
                                <h4 class="font-weight-medium mb-0">
                                    {{ student.additionals.diterima_jalur }}
                                </h4>
                            </div>
                        </div>
                        <div class="row mb-1 align-items-center">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted h4 mb-0 form-divider">Pembayaran Tahap 2</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 p-1">
                                <h4 class="font-weight-medium mb-0">
                                    {{ student.additionals.diterima_univ }}
                                </h4>
                            </div>
                        </div>
                        <div class="row mb-1 align-items-center" v-for="attribute in ['diterima_prodi']">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted h4 mb-0 form-divider">Pembayaran Tahap 3</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 p-1">
                                <h4 class="font-weight-medium mb-0">
                                    {{ student.additionals[attribute] }}
                                </h4>
                            </div>
                        </div>
                        <div class="row mb-1 align-items-center" v-for="n in 3">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted h4 mb-0 form-divider">Sekolah/ Universitas Impian {{ n }}</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 p-1">
                                <input v-model="form.profile['sekolah_impian_' + n]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                            </div>
                        </div>
                    </div>
                </div>

	    </form>
	
	    
                <!-- Section 2 -->
                <div class="card shadow-sm mb-4 border-0">
                    <div class="card-header background-primary">
                        <div class="row">
                            <div class="col">
                                <span class="h4 font-weight-medium text-white mb-0">
                                    Data Orang Tua Siswa
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row mb-1 align-items-center" v-for="attribute in ['nama_ayah', 'nomor_hp_ayah', 'email_ayah', 'pekerjaan_ayah', 'nama_ibu', 'nomor_hp_ibu', 'email_ibu', 'pekerjaan_ibu']">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted h4 mb-0 form-divider">{{ humanize(attribute) }}</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 p-1">
                                <h4 class="font-weight-medium mb-0">
                                    {{ student.additionals[attribute] }}
                                </h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <template v-if="student.grade.level >= 12">
                <div class="col-lg-3 col-sm-6">
                    <!-- Section 4 -->
                    <form v-on:submit.prevent="save" disabled>
                        <div class="card shadow-sm mb-4 border-0">
                            <div class="card-header background-primary">
                                <div class="row">
                                    <div class="col">
                                        <span class="h4 font-weight-medium text-white mb-0">
                                            Data Kepesertaan SNMPTN
                                        </span>
                                    </div>
                                    <div class="col-auto">
                                        <div class="edit-action">
                                            <button type="button" class="btn btn-link h4 p-0 my-0" v-on:click="toggleInput">
                                                Edit
                                            </button>
                                        </div>
                                        <div class="input-action">
                                            <button type="submit" class="btn btn-danger btn-sm btn-outline-white h4 my-0 mr-2">
                                                Save
                                            </button>
                                            <button type="button" class="btn btn-danger btn-sm btn-outline-white h4 my-0" v-on:click="toggleInput">
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="row mb-1 align-items-center" v-for="attribute in ['SNMPTN_nomor']">
                                    <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                        <label class="font-weight-medium text-muted h4 mb-0 form-divider">{{ humanize(attribute) }}</label>
                                    </div>
                                    <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                        <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                    </div>
                                </div>
                                <template v-for="n in 3">
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted h4 mb-0 form-divider">Univ {{ n }}</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.profile['SNMPTN_univ_' + n]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted h4 mb-0 form-divider">Prodi {{ n }}</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.profile['SNMPTN_prodi_' + n]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </form>

                    <!-- Section 5 -->
		    <form v-on:submit.prevent="save" disabled>
                    <div class="card shadow-sm mb-4 border-0">
                        <div class="card-header background-primary">
                            <div class="row">
                                <div class="col">
                                    <span class="h4 font-weight-medium text-white mb-0">
                                        Data Kepesertaan SBMPTN
                                    </span>
                                </div>
				<div class="col-auto">
                                        <div class="edit-action">
                                            <button type="button" class="btn btn-link h4 p-0 my-0" v-on:click="toggleInput">
                                                Edit
                                            </button>
                                        </div>
                                        <div class="input-action">
                                            <button type="submit" class="btn btn-danger btn-sm btn-outline-white h4 my-0 mr-2">
                                                Save
                                            </button>
                                            <button type="button" class="btn btn-danger btn-sm btn-outline-white h4 my-0" v-on:click="toggleInput">
                                                Cancel
                                            </button>
                                        </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row mb-1 align-items-center" v-for="attribute in ['SBMPTN_nomor']">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider">{{ humanize(attribute) }}</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                </div>
                            </div>
                            <template v-for="n in 2">
                                <div class="row mb-1 align-items-center">
                                    <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                        <label class="font-weight-medium text-muted h4 mb-0 form-divider">Univ {{ n }}</label>
                                    </div>
                                    <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                        <input v-model="form.profile['SBMPTN_univ_' + n]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                    </div>
                                </div>
                                <div class="row mb-1 align-items-center">
                                    <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                        <label class="font-weight-medium text-muted h4 mb-0 form-divider">Prodi {{ n }}</label>
                                    </div>
                                    <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                        <input v-model="form.profile['SBMPTN_prodi_' + n]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                    </div>
                                </div>
                            </template>
			    <!--
                            <template v-for="n in 2">
                                <div class="row mb-1 align-items-center">
                                    <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                        <label class="font-weight-medium text-muted h4 mb-0 form-divider">Nilai UTBK {{ n }}</label>
                                    </div>
                                    <div class="col-lg-7 col-md-12 col-sm-7 p-1">
                                        <h4 class="font-weight-medium mb-0">
                                            {{ student.additionals['nilai_UTBK_' + n] }}
                                        </h4> 
                                    </div>
                                </div>
                                <div class="row mb-1 align-items-center">
                                    <div class="col-sm-5 col-12 p-1">
                                        <label class="font-weight-medium mb-0 h4 form-divider text-muted">
                                            File UTBK {{ n }}
                                        </label>
                                    </div>
                                    <div class="col-sm-7 col-12 px-1">
                                        <button v-on:click="download(n)" type="button" class="btn btn-sm btn-link font-weight-medium p-0" v-if="student.additionals['file_UTBK_' + n]">
                                            <file-icon v-bind:type="fileExtension(student.additionals['file_UTBK_' + n])" class="mr-1"></file-icon> Download
                                        </button>
                                        <i class="fa fa-minus" v-else></i>
                                    </div>
                                </div>
                            </template>-->
                        </div>
                    </div>
		    </form>
                    <!-- Section 6 -->
                    <form v-on:submit.prevent="save" disabled>
                        <div class="card shadow-sm mb-4 border-0">
                            <div class="card-header background-primary">
                                <div class="row">
                                    <div class="col">
                                        <span class="h4 font-weight-medium text-white mb-0">
                                            Data Kepesertaan Ujian Mandiri
                                        </span>
                                    </div>
                                    <div class="col-auto">
                                        <div class="edit-action">
                                            <button type="button" class="btn btn-link h4 p-0 my-0" v-on:click="toggleInput">
                                                Edit
                                            </button>
                                        </div>
                                        <div class="input-action">
                                            <button type="submit" class="btn btn-danger btn-sm btn-outline-white h4 my-0 mr-2">
                                                Save
                                            </button>
                                            <button type="button" class="btn btn-danger btn-sm btn-outline-white h4 my-0" v-on:click="toggleInput">
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <template v-for="n in 2">
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted h4 mb-0 form-divider">Nomor Ujian Mandiri {{ n }}</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.profile['Mandiri_' + n + '_nomor']" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted h4 mb-0 form-divider">Universitas Ujian Mandiri {{ n }}</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.profile['Mandiri_' + n + '_univ']" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted h4 mb-0 form-divider">Prodi Ujian Mandiri {{ n }}</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.profile['Mandiri_' + n + '_prodi']" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </form>
                </div>

                <div class="col-lg-3 col-sm-6">
                    <!-- Section 7 
                    <form v-on:submit.prevent="save" disabled>
                        <div class="card shadow-sm mb-4 border-0">
                            <div class="card-header background-primary">
                                <div class="row">
                                    <div class="col">
                                        <span class="h4 font-weight-medium text-white mb-0">
                                            Data Kepesertaan PPKB
                                        </span>
                                    </div>
                                    <div class="col-auto">
                                        <div class="edit-action">
                                            <button type="button" class="btn btn-link h4 p-0 my-0" v-on:click="toggleInput">
                                                Edit
                                            </button>
                                        </div>
                                        <div class="input-action">
                                            <button type="submit" class="btn btn-danger btn-sm btn-outline-white h4 my-0 mr-2">
                                                Save
                                            </button>
                                            <button type="button" class="btn btn-danger btn-sm btn-outline-white h4 my-0" v-on:click="toggleInput">
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="row mb-1 align-items-center" v-for="attribute in ['PPKB_nomor', 'PPKB_univ', 'PPKB_prodi']">
                                    <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                        <label class="font-weight-medium text-muted h4 mb-0 form-divider">{{ humanize(attribute) }}</label>
                                    </div>
                                    <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                        <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>-->

                    <!-- Section 8 
                    <form v-on:submit.prevent="save" disabled>
                        <div class="card shadow-sm mb-4 border-0">
                            <div class="card-header background-primary">
                                <div class="row">
                                    <div class="col">
                                        <span class="h4 font-weight-medium text-white mb-0">
                                            Data Kepesertaan Talent Scouting
                                        </span>
                                    </div>
                                    <div class="col-auto">
                                        <div class="edit-action">
                                            <button type="button" class="btn btn-link h4 p-0 my-0" v-on:click="toggleInput">
                                                Edit
                                            </button>
                                        </div>
                                        <div class="input-action">
                                            <button type="submit" class="btn btn-danger btn-sm btn-outline-white h4 my-0 mr-2">
                                                Save
                                            </button>
                                            <button type="button" class="btn btn-danger btn-sm btn-outline-white h4 my-0" v-on:click="toggleInput">
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="row mb-1 align-items-center" v-for="attribute in ['TS_nomor', 'TS_univ', 'TS_prodi']">
                                    <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                        <label class="font-weight-medium text-muted h4 mb-0 form-divider">{{ humanize(attribute) }}</label>
                                    </div>
                                    <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                        <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>-->

                    <!-- Section 9 
                    <form v-on:submit.prevent="save" disabled>
                        <div class="card shadow-sm mb-4 border-0">
                            <div class="card-header background-primary">
                                <div class="row">
                                    <div class="col">
                                        <span class="h4 font-weight-medium text-white mb-0">
                                            Data Kepesertaan IUP UGM
                                        </span>
                                    </div>
                                    <div class="col-auto">
                                        <div class="edit-action">
                                            <button type="button" class="btn btn-link h4 p-0 my-0" v-on:click="toggleInput">
                                                Edit
                                            </button>
                                        </div>
                                        <div class="input-action">
                                            <button type="submit" class="btn btn-danger btn-sm btn-outline-white h4 my-0 mr-2">
                                                Save
                                            </button>
                                            <button type="button" class="btn btn-danger btn-sm btn-outline-white h4 my-0" v-on:click="toggleInput">
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="row mb-1 align-items-center" v-for="attribute in ['IUP_nomor', 'IUP_prodi']">
                                    <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                        <label class="font-weight-medium text-muted h4 mb-0 form-divider">{{ humanize(attribute) }}</label>
                                    </div>
                                    <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                        <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>-->

                    <!-- Section 10 -->
                    <!--<form v-on:submit.prevent="save" disabled>
                        <div class="card shadow-sm mb-4 border-0">
                            <div class="card-header background-primary">
                                <div class="row">
                                    <div class="col">
                                        <span class="h4 font-weight-medium text-white mb-0">
                                            Data Kepesertaan SIMAK UI
                                        </span>
                                    </div>
                                    <div class="col-auto">
                                        <div class="edit-action">
                                            <button type="button" class="btn btn-link h4 p-0 my-0" v-on:click="toggleInput">
                                                Edit
                                            </button>
                                        </div>
                                        <div class="input-action">
                                            <button type="submit" class="btn btn-danger btn-sm btn-outline-white h4 my-0 mr-2">
                                                Save
                                            </button>
                                            <button type="button" class="btn btn-danger btn-sm btn-outline-white h4 my-0" v-on:click="toggleInput">
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="row mb-1 align-items-center" v-for="attribute in ['SIMAK_nomor']">
                                    <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                        <label class="font-weight-medium text-muted h4 mb-0 form-divider">{{ humanize(attribute) }}</label>
                                    </div>
                                    <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                        <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                    </div>
                                </div>
                                <div class="row mb-1 align-items-center" v-for="n in 7">
                                    <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                        <label class="font-weight-medium text-muted h4 mb-0 form-divider">Prodi {{ n }}</label>
                                    </div>
                                    <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                        <input v-model="form.profile['SIMAK_prodi_' + n]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>-->

										<!-- Section 11 -->
                    <form v-on:submit.prevent="save" disabled>
                        <div class="card shadow-sm mb-4 border-0">
                            <div class="card-header background-primary">
                                <div class="row">
                                    <div class="col">
                                        <span class="h4 font-weight-medium text-white mb-0">
                                            Data Penerimaan Kuliah
                                        </span>
                                    </div>
                                    <div class="col-auto">
                                        <div class="edit-action">
                                            <button type="button" class="btn btn-link h4 p-0 my-0" v-on:click="toggleInput">
                                                Edit
                                            </button>
                                        </div>
                                        <div class="input-action">
                                            <button type="submit" class="btn btn-danger btn-sm btn-outline-white h4 my-0 mr-2">
                                                Save
                                            </button>
                                            <button type="button" class="btn btn-danger btn-sm btn-outline-white h4 my-0" v-on:click="toggleInput">
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="row mb-1 align-items-center">
                                    <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                        <label class="font-weight-medium text-muted h4 mb-0 form-divider">Universitas 1</label>
                                    </div>
                                    <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                        <div class="multiselect-wrapper">
                                            <multiselect
                                                id="multiselect-penerimaan-university-1"
                                                v-model="selectedPenerimaanUniversity"
                                                v-bind:options="universities"
                                                tag-placeholder=""
                                                select-label=""
                                                label="name"
                                                track-by="name"
                                                placeholder="Universitas 1"
                                                class="form-control form-control-sm toggle-multiselect"
                                            ></multiselect>
                                        </div>
                                        <input v-model="form.profile.Penerimaan_univ_1" disabled class="form-control-plaintext h4 mb-0 font-weight-medium form-control-sm multiselect-readonly" />
                                    </div>
                                </div>
                                <div class="row mb-1 align-items-center" v-if="form.profile.Penerimaan_univ_1">
                                    <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                        <label class="font-weight-medium text-muted h4 mb-0 form-divider">Prodi 1</label>
                                    </div>
                                    <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                        <div class="multiselect-wrapper">
                                            <multiselect
                                                v-model="selectedPenerimaanCourse"
                                                v-on:select="(universityCourse) => (form.profile.Penerimaan_prodi_1 = universityCourse.name)"
                                                v-on:remove="() => (form.profile.Penerimaan_prodi_1 = '')"
                                                v-bind:options="penerimaanUniversityCourses"
                                                tag-placeholder=""
                                                select-label=""
                                                label="name"
                                                track-by="name"
                                                placeholder="Prodi 1"
                                                class="form-control form-control-sm toggle-multiselect"
                                            ></multiselect>
                                        </div>
                                        <input v-model="form.profile.Penerimaan_prodi_1" disabled class="form-control-plaintext h4 mb-0 font-weight-medium form-control-sm multiselect-readonly" />
                                    </div>
                                </div>
                                <div class="row mb-1 align-items-center">
                                    <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                        <label class="font-weight-medium text-muted h4 mb-0 form-divider">Universitas 2</label>
                                    </div>
                                    <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                        <div class="multiselect-wrapper">
                                            <multiselect
                                                id="multiselect-penerimaan-university-2"
                                                v-model="selectedPenerimaanUniversity2"
                                                v-bind:options="universities"
                                                tag-placeholder=""
                                                select-label=""
                                                label="name"
                                                track-by="name"
                                                placeholder="Universitas 2"
                                                class="form-control form-control-sm toggle-multiselect"
                                            ></multiselect>
                                        </div>
                                        <input v-model="form.profile.Penerimaan_univ_2" disabled class="form-control-plaintext h4 mb-0 font-weight-medium form-control-sm multiselect-readonly" />
                                    </div>
                                </div>
                                <div class="row mb-1 align-items-center" v-if="form.profile.Penerimaan_univ_2">
                                    <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                        <label class="font-weight-medium text-muted h4 mb-0 form-divider">Prodi 2</label>
                                    </div>
                                    <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                        <div class="multiselect-wrapper">
                                            <multiselect
                                                v-model="selectedPenerimaanCourse2"
                                                v-on:select="(universityCourse) => (form.profile.Penerimaan_prodi_2 = universityCourse.name)"
                                                v-on:remove="() => (form.profile.Penerimaan_prodi_2 = '')"
                                                v-bind:options="penerimaanUniversityCourses2"
                                                tag-placeholder=""
                                                select-label=""
                                                label="name"
                                                track-by="name"
                                                placeholder="Prodi 2"
                                                class="form-control form-control-sm toggle-multiselect"
                                            ></multiselect>
                                        </div>
                                        <input v-model="form.profile.Penerimaan_prodi_2" disabled class="form-control-plaintext h4 mb-0 font-weight-medium form-control-sm multiselect-readonly" />
                                    </div>
                                </div>
                                <div class="row mb-1 align-items-center">
                                    <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                        <label class="font-weight-medium text-muted h4 mb-0 form-divider">Universitas 3</label>
                                    </div>
                                    <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                        <input v-model="form.profile.Penerimaan_univ_3" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" placeholder="Ketik nama Universitas (jika tidak ada di pilihan)" />
                                    </div>
                                </div>
                                <div class="row mb-1 align-items-center" v-show="form.profile.Penerimaan_univ_3">
                                    <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                        <label class="font-weight-medium text-muted h4 mb-0 form-divider">Prodi 3</label>
                                    </div>
                                    <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                        <input v-model="form.profile.Penerimaan_prodi_3" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" placeholder="Ketik nama Prodi" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </template>
        </div>
        <b-modal v-model="modalShow" modal-class="border-0" header-class="background-primary" footer-class="justify-content-center" v-bind:centered="true" v-bind:hide-footer="true">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Request Edit
                </h4>
            </template>
            <div class="container text-center">
                <form v-on:submit.prevent="submit">
                    <div class="row">
                        <div class="col-12 mb-2">
                            <div class="form-group">
                                <label class="font-weight-bold h4 mb-4 mt-2">
                                    Tuliskan bagian data yang ingin diubah dan data baru sebagai penggantinya
                                </label>
                                <textarea v-model="form.request.content" class="form-control form-control-sm" rows="6" spellcheck="false" required></textarea>
                            </div>
                        </div>
                        <div class="col-12">
                            <button class="btn btn-danger btn-sm px-5" type="submit">
                                Request Edit
                            </button>
                            <button class="btn btn-outline-danger btn-sm px-5 ml-3" v-on:click="modalShow = false">
                                Batal
                            </button>        
                        </div>
                    </div>
                </form>
            </div>
        </b-modal>
	<div class="row">
            <div class="col text-center mt-5">
                <Adsense v-bind:data-ad-client="googleAdsClientKey" data-ad-slot="8773918261"></Adsense>
            </div>
        </div>
    </section>
</template>

<script>
    import FileIcon from "@/components/item/FileIcon";
		import Multiselect from 'vue-multiselect';
    import qs from 'qs';

    export default {
        name: "AccountStudentProfile",
        components: {
            FileIcon,
            Multiselect
        },
        data() {
            return {
                student: {
                    branch: {}, user: {}, school: {}, grade: {}, btaGrade: {},
                    studentVerified: {pattern: {brachProgram: {}}, branchClass: {}},
                    additionals: {}, term: {}
                },
                form: {
                    student: {
                        image: ''
                    },
                    request: {
                        content: ''
                    },
                    profile: {
                        SNMPTN_nomor: '', SNMPTN_univ_1: '', SNMPTN_prodi_1: '', SNMPTN_univ_2: '', SNMPTN_prodi_2: '', SNMPTN_univ_3: '', SNMPTN_prodi_3: '',
                        PPKB_nomor: '', PPKB_univ: '', PPKB_prodi: '',
                        TS_nomor: '', TS_univ: '', TS_prodi: '',
                        IUP_nomor: '', IUP_prodi: '',
                        SIMAK_nomor: '', SIMAK_prodi_1: '', SIMAK_prodi_2: '', SIMAK_prodi_3: '', SIMAK_prodi_4: '', SIMAK_prodi_5: '', SIMAK_prodi_6: '', SIMAK_prodi_7: '',
                        Mandiri_1_nomor: '', Mandiri_1_univ: '', Mandiri_1_prodi: '', Mandiri_2_nomor: '', Mandiri_2_univ: '', Mandiri_2_prodi: '', Mandiri_3_nomor: '', Mandiri_3_univ: '', Mandiri_3_prodi: '',
                        Penerimaan_univ_1: '', Penerimaan_prodi_1: '', Penerimaan_univ_2: '', Penerimaan_prodi_2: '', Penerimaan_univ_3: '', Penerimaan_prodi_3: ''
                    }
                },
                universities: [],
                penerimaanUniversityCourses: [],
                selectedPenerimaanUniversity: null,
                selectedPenerimaanCourse: null,
                penerimaanUniversityCourses2: [],
                selectedPenerimaanUniversity2: null,
                selectedPenerimaanCourse2: null,
                guessBranchProgram: {},
                modalShow: false,
		googleAdsClientKey: process.env.GOOGLE_ADS_CLIENT,
                imagePreview: ''
            };
        },
				watch: {
            selectedPenerimaanUniversity(university) {
                if (university) {
                    if (this.form.profile.Penerimaan_univ_1 && this.form.profile.Penerimaan_univ_1 !== university.name) {
                        this.selectedPenerimaanCourse = null;
                        this.form.profile.Penerimaan_prodi_1 = '';
                    }
                    this.form.profile.Penerimaan_univ_1 = university.name;
                    this.axios.get(process.env.API_URL + '/university-course', {
                        params: {
                            universityID: university.id,
                            pagination: 0
                        }
                    }).then(response => {
                        this.penerimaanUniversityCourses = response.data.data.data;
                        if (this.form.profile.Penerimaan_prodi_1) {
                            this.selectedPenerimaanCourse = this.penerimaanUniversityCourses.find(c => c.name === this.form.profile.Penerimaan_prodi_1) || null;
                        }
                    });
                } else {
                    this.form.profile.Penerimaan_univ_1 = '';
                    this.penerimaanUniversityCourses = [];
                    this.selectedPenerimaanCourse = null;
                    this.form.profile.Penerimaan_prodi_1 = '';
                }
            },
            selectedPenerimaanUniversity2(university) {
                if (university) {
                    if (this.form.profile.Penerimaan_univ_2 && this.form.profile.Penerimaan_univ_2 !== university.name) {
                        this.selectedPenerimaanCourse2 = null;
                        this.form.profile.Penerimaan_prodi_2 = '';
                    }
                    this.form.profile.Penerimaan_univ_2 = university.name;
                    this.axios.get(process.env.API_URL + '/university-course', {
                        params: {
                            universityID: university.id,
                            pagination: 0
                        }
                    }).then(response => {
                        this.penerimaanUniversityCourses2 = response.data.data.data;
                        if (this.form.profile.Penerimaan_prodi_2) {
                            this.selectedPenerimaanCourse2 = this.penerimaanUniversityCourses2.find(c => c.name === this.form.profile.Penerimaan_prodi_2) || null;
                        }
                    });
                } else {
                    this.form.profile.Penerimaan_univ_2 = '';
                    this.penerimaanUniversityCourses2 = [];
                    this.selectedPenerimaanCourse2 = null;
                    this.form.profile.Penerimaan_prodi_2 = '';
                }
            }
        },
        methods: {
            save(event) {
                this.axios.post(process.env.API_URL + '/student/profile-edit', {profile: this.form.profile}).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.toggleInput(event);
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            humanize(string) {
                return string.replace(/[_]+/g, ' ').replace(/^[a-z]| [a-z]/g, function (character) {
                    return character.toUpperCase();
                });
            },
            patternLabel(pattern) {
                return pattern.periods.map(period => {
                    return this.$moment.weekdays(period.day) + ' ' + this.$moment(period.start, "HH:mm:ss").format('HH.mm') + ' - ' + this.$moment(period.end, "HH:mm:ss").format('HH.mm');
                }).join(" | ");
            },
            preview(event) {
                var input = event.currentTarget;
                if (input.files && input.files[0]) {
                    this.form.student.image = input.files[0];
                    var reader = new FileReader();
                    reader.onload = function (event) {
                        this.imagePreview = event.target.result;
                    }.bind(this);
                    reader.readAsDataURL(input.files[0]);
                }
            },
            upload() {
                var formData = new FormData();
                for (var attribute in this.form.student) {
                    formData.set(attribute, this.form.student[attribute]);
                }
                this.axios.post(process.env.API_URL + '/student/photo', formData).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            toggleInput(event) {
                var form = event.currentTarget ? event.currentTarget.form : event.target;
                var editMode = form.hasAttribute('disabled');
                if (editMode) {
                    var forms = document.querySelectorAll('form:not([disabled])');
                    for (var i = 0; i < forms.length; i++) {
                        this.formState(forms[i], false);
                    }
                    if (forms.length) {
                        this.fetchStudent();
                    }
                } else {
                    this.fetchStudent();
                }
                this.formState(form, editMode);
            },
            formState(form, editMode) {
                if (editMode) {
                    form.removeAttribute('disabled');
                } else {
                    form.setAttribute('disabled', 'disabled');
                }
                var inputs = form.getElementsByClassName('toggle-input');
                for (var i = 0; i < inputs.length; i++) {
                    var input = inputs[i];
                    if (editMode) {
                        input.classList.add('form-control');
                        input.classList.remove('form-control-plaintext');
                        input.removeAttribute("disabled");
                    } else {
                        input.classList.add('form-control-plaintext');
                        input.classList.remove('form-control');
                        input.setAttribute('disabled', 'disabled');
                    }
                }
            },
            fetchStudent() {
                this.axios.get(process.env.API_URL + '/student/profile').then(response => {
                    this.student = response.data.data;
                    if (this.student.studentVerified) {
                        if (this.student.studentVerified.pattern) {
                            this.guessBranchProgram = this.student.studentVerified.pattern.branchProgram;
                        } else if (this.student.studentVerified.intensiveSchedule) {
                            this.guessBranchProgram = this.student.studentVerified.intensiveSchedule.branchProgram;
                        }
                    }
                    this.imagePreview = this.student.imageUrl;
                    this.form.profile = Object.assign({
                        Penerimaan_univ_1: '', Penerimaan_prodi_1: '', 
                        Penerimaan_univ_2: '', Penerimaan_prodi_2: '', 
                        Penerimaan_univ_3: '', Penerimaan_prodi_3: ''
                    }, this.student.additionals);
                    if (this.universities && this.universities.length && this.form.profile.Penerimaan_univ_1) {
                        this.selectedPenerimaanUniversity = this.universities.find(u => u.name === this.form.profile.Penerimaan_univ_1);
                    }
                    if (this.universities && this.universities.length && this.form.profile.Penerimaan_univ_2) {
                        this.selectedPenerimaanUniversity2 = this.universities.find(u => u.name === this.form.profile.Penerimaan_univ_2);
                    }
                });
            },
            submit() {
                this.axios.post(process.env.API_URL + '/student/request-edit', this.form.request).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.modalShow = false;
                        this.form.request = {content: ''};
                    } else {
                        this.$toastr('warning', response.data.message, 'Warning');
                    }
                });
            },
            download(index) {
                let token = localStorage.getItem("vue-authenticate.vueauth_token");
                window.location = process.env.API_URL + '/student/download-utbk?' + qs.stringify({index: index, token: token}, {encode: false});
            },
            fileExtension(filename) {
                return filename.split('.').pop() || '';
            }
        },
        created() {
            this.axios.get(process.env.API_URL + '/university').then(response => {
                this.universities = response.data.data;
                this.fetchStudent();
            }).catch(e => {
                this.fetchStudent();
            });
        }
    };
</script>

<style scoped>
    img:not([src]), img[src=""]{ display: none; }
    .btn.btn-outline-white { border-color: #fff; }
    .card-body { padding-left: 1.9rem; padding-right: 1.9rem; }

    @media (max-width: 991.98px) {
        .form-divider::before{ display: none; }
    }
    form .edit-action, form[disabled] .input-action { display: none; }
    form .input-action, form[disabled] .edit-action { display: block; }
    
    form[disabled] .multiselect-wrapper { display: none; }
    form:not([disabled]) .multiselect-readonly { display: none !important; }

    form[disabled] select.form-control-plaintext { -moz-appearance: none; -webkit-appearance: none; appearance: none; }
    form:not([disabled]) .wrapper-input + .toggle-input, form[disabled] .wrapper-input { display: none; }

</style>

<style>
    /* Ukuran placeholder untuk Univ & Prodi, warna super pudar (#ccc) */
    .card-body .toggle-input::-webkit-input-placeholder { color: #ccc !important; font-size: 0.75em !important; }
    .card-body .toggle-input::-moz-placeholder { color: #ccc !important; font-size: 0.75em !important; }
    .card-body .toggle-input:-ms-input-placeholder { color: #ccc !important; font-size: 0.75em !important; }
    .card-body .toggle-input::placeholder { color: #ccc !important; font-size: 0.75em !important; }

    /* Tulisan abu-abu pudar di dropdown Univ/Prodi sebelum diklik */
    .card-body .toggle-multiselect .multiselect__placeholder { color: #ccc !important; font-size: 0.75em !important; display: inline-block; padding-top: 2px; }

    /* BENAR-BENAR HILANGKAN tulisan di search box saat diklik (Hanya bekerja di luar scoped / v-deep) */
    .card-body .toggle-multiselect .multiselect__input::-webkit-input-placeholder { color: transparent !important; }
    .card-body .toggle-multiselect .multiselect__input::-moz-placeholder { color: transparent !important; }
    .card-body .toggle-multiselect .multiselect__input:-ms-input-placeholder { color: transparent !important; }
    .card-body .toggle-multiselect .multiselect__input::placeholder { color: transparent !important; }

    /* Sembunyikan ketika mode disabled */
    form[disabled] .card-body .toggle-input::-webkit-input-placeholder { color: transparent !important; }
    form[disabled] .card-body .toggle-input::-moz-placeholder { color: transparent !important; }
    form[disabled] .card-body .toggle-input:-ms-input-placeholder { color: transparent !important; }
    form[disabled] .card-body .toggle-input::placeholder { color: transparent !important; }

    form[disabled] .card-body .toggle-multiselect .multiselect__placeholder { color: transparent !important; }
</style>


// WEBPACK FOOTER //
// src/components/account/student/Profile.vue